'use strict';
'use es6';

/**
 * Object.is polyfill (required for IE11)
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
}; // eslint-disable-line no-self-compare


module.exports = exports['default'];